var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInviteTicketLine = function SvgInviteTicketLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.00024 7.48777C4.00024 6.53342 4.76776 5.75977 5.71453 5.75977H13.0002L13.0002 10.0798H5.71453C4.76776 10.0798 4.00024 9.30611 4.00024 8.35177L4.00024 7.48777Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.85739 11.3758H13.0002V23.0398H6.57167C5.6249 23.0398 4.85739 22.2661 4.85739 21.3118V11.3758Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0002 7.48777C28.0002 6.53342 27.2327 5.75977 26.286 5.75977H19.0002V10.0798H26.286C27.2327 10.0798 28.0002 9.30611 28.0002 8.35177V7.48777Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1431 11.3758H19.0002V23.0398H25.4288C26.3756 23.0398 27.1431 22.2661 27.1431 21.3118V11.3758Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0003 5.12C16.0003 5.12 12.448 5.12 10.7238 4.34763C9.33787 3.7268 9.66949 2.54865 10.3373 1.42929C11.0051 0.309934 11.8202 -0.444519 13.1421 0.294066C14.8756 1.26265 16.0003 3.41333 16.0003 3.41333C16.0003 3.41333 17.1249 1.26265 18.8585 0.294066C20.1803 -0.444519 20.9955 0.309934 21.6632 1.42929C22.331 2.54865 22.6626 3.72677 21.2767 4.34763C19.5526 5.12 16.0003 5.12 16.0003 5.12Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2242 23.04L14.2242 5.97333H17.7765V23.04H14.2242Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.00024 28.5C9.00024 27.6716 8.32867 27 7.50024 27H1.50024C0.671817 27 0.000244141 27.6716 0.000244141 28.5C0.000244141 29.3284 0.671817 30 1.50024 30H7.50024C8.32867 30 9.00024 29.3284 9.00024 28.5Z",
    fill: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5002 27C20.3287 27 21.0002 27.6716 21.0002 28.5C21.0002 29.3284 20.3287 30 19.5002 30H12.5002C11.6718 30 11.0002 29.3284 11.0002 28.5C11.0002 27.6716 11.6718 27 12.5002 27H19.5002Z",
    fill: "currentColor"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0002 28.5C32.0002 27.6716 31.3287 27 30.5002 27H24.5002C23.6718 27 23.0002 27.6716 23.0002 28.5C23.0002 29.3284 23.6718 30 24.5002 30H30.5002C31.3287 30 32.0002 29.3284 32.0002 28.5Z",
    fill: "currentColor"
  })));
};
export default SvgInviteTicketLine;